const LOGOS = [
  ["delhivery", "delhivery.png"], ["blue dart", "bluedart.png"], ["bluedart", "bluedart.png"],
  ["amazon", "amazon.svg"], ["ekart", "ekart.png"], ["xpressbees", "xpressbees.png"], ["dtdc", "dtdc.png"],
  ["shadowfax", "shadowfax.png"], ["ecom", "ecom.png"], ["india post", "indiapost.png"], ["speed post", "indiapost.png"],
  ["rapido", "rapido.png"], ["fedex", "fedex.svg"], ["loadshare", "loadshare.png"],
  ["uber", "uber.svg"], ["scooton", "scooton.png"], ["blitz", "blitz.svg"], ["delpick", "delpick.png"],
  ["bijliride", "bijliride.png"], ["srola", "ola.svg"], ["ola_", "ola.svg"], ["ola ", "ola.svg"],
];

export const courierLogoUrl = (name) => {
  const n = (name || "").toLowerCase();
  const hit = LOGOS.find(([k]) => n.includes(k));
  return hit ? `/couriers/${hit[1]}` : null;
};

// Courier logo kept in its real proportions inside a small box; renders nothing for unknown couriers.
export const CourierLogo = ({ name, className = "" }) => {
  const src = courierLogoUrl(name);
  if (!src) return null;
  return (
    <span className={`inline-flex h-6 w-16 shrink-0 items-center justify-center ${className}`} data-testid="courier-logo">
      <img src={src} alt={`${name} logo`} className="max-h-full max-w-full object-contain" loading="lazy" />
    </span>
  );
};
